import React from 'react';
import { FadeIn } from './FadeIn';
import { ClipboardList, Users, GitBranch, Settings } from 'lucide-react';
const pillars = [{
  icon: ClipboardList,
  title: 'Procesos claros',
  desc: 'La operación tiene lógica definida'
}, {
  icon: Users,
  title: 'Equipo con dirección',
  desc: 'Cada quien sabe qué hacer y por qué'
}, {
  icon: GitBranch,
  title: 'Decisiones que fluyen',
  desc: 'Sin cuellos de botella ni dependencias'
}, {
  icon: Settings,
  title: 'Operación con lógica',
  desc: 'El negocio funciona, no solo sobrevive'
}];
export function SolutionSection() {
  return <section className="py-24 px-6 bg-navy" data-id="element-136">
      <div className="max-w-5xl mx-auto" data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <FadeIn data-id="element-139">
            <h2 className="text-3xl md:text-5xl font-serif mb-8" data-id="element-140">
              La solución no es trabajar más… <br data-id="element-141" />
              <span className="text-gold" data-id="element-142">es estructurar mejor</span>
            </h2>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-143">
            <p className="text-xl text-gray-light max-w-3xl mx-auto mb-10" data-id="element-144">
              La mayoría intenta resolver esto con más esfuerzo, más control o
              más reuniones. Pero eso solo aumenta la carga.
            </p>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-145">
            <div className="inline-block bg-gold/10 border border-gold/30 px-8 py-4 rounded-lg" data-id="element-146">
              <p className="text-xl md:text-2xl font-medium text-white" data-id="element-147">
                Lo que necesitas es una estructura operativa que sostenga el
                negocio sin fricción.
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-148">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <FadeIn key={i} delay={0.3 + i * 0.1} data-id="element-149">
                <div className="p-8 rounded-xl border border-gold/20 bg-white/[0.02] hover:bg-white/[0.04] transition-colors flex flex-col items-center text-center h-full" data-id="element-150">
                  <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mb-6" data-id="element-151">
                    <Icon className="w-8 h-8 text-gold" data-id="element-152" />
                  </div>
                  <h3 className="text-2xl font-serif text-white mb-3" data-id="element-153">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-light text-lg" data-id="element-154">{pillar.desc}</p>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.6} data-id="element-155">
          <div className="text-center max-w-3xl mx-auto" data-id="element-156">
            <p className="text-lg md:text-xl text-gray-light leading-relaxed" data-id="element-157">
              No se trata de organizar mejor… Se trata de diseñar el negocio
              como un sistema. Integrando estrategia, ingeniería, liderazgo y
              tecnología.{' '}
              <span className="text-white font-medium" data-id="element-158">
                Para convertir el caos en control.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}